module.exports = __webpack_public_path__ + "img/potencia_r_c_red.00458160.svg";